import { useState, useEffect, useMemo, useRef } from "react";
import Modal from "react-modal";
import Action from "../Action";
import LoadSimple from "../LoadSimple";
import "./AfiliationMap/styles/panel.css";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import MapboxAfiliation from "./AfiliationMap/MapboxAfiliation";
import FilterPanel from "./AfiliationMap/FilterPanel";
import PanelCorrelaciones from './AfiliationMap/PanelCorrelaciones'
import AffStatBarNew from "./AfiliationMap/components/AffStatBarNew";
// import {dataAffiliation} from "./AfiliationMap/dataAfiliations"
import { da, de } from "date-fns/locale";
import ModalHostList from "./AfiliationMap/ModalHostLis";
import ModalHostStatusList from "./AfiliationMap/ModalHostStatusList";
import ModalHostStatusListNew from "./AfiliationMap/ModalHostStatusListNew";
import InfoStatus from "../InfoStatus";
import LoadData from "../LoadData";
const infoMarkerStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#363636',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    height: '80%',
    padding: '20px'
  },
};
// Wrapper para el nuevo modal de lista de dispositivos
const statusListModalStyles = {
  content: {
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'transparent',
    border: 'none',
    padding: 0,
    overflow: 'visible',
  },
  overlay: {
    background: 'rgba(15,30,56,0.4)',
    zIndex: 49,
  },
};
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "40%",
    padding: "20px",
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    padding: "20px",
  },
};

const PanelAfiliationMap = ({ server, languaje, mode, handleShowPopup, hostSelected,
  setHostSelected,
  dataServers,
  listSelected,
  techSelected,
  openAddHostModal,
  dataCriticalities, dataAgencies, dataGlobals,
  showHistoric }) => {
  const [dataAffiliation, setDataAffiliation] = useState({ affiliations: [], correlations: [], dashboard_summary: {}, catalogs: { technologies: [], groups: [], zones: [] } })
  const dispId_default = -1
  const global_longitud = dataGlobals.find(obj => obj.name === 'state_longitude')
  const global_latitude = dataGlobals.find(obj => obj.name === 'state_latitude')
  const global_zoom = dataGlobals.find(obj => obj.name === 'zoom')
  const [ubicacion, setUbicacion] = useState({ latitud: global_latitude.value, longitud: global_longitud.value, groupid: 0, dispId: dispId_default, templateId: 0 })
  const [mapAux, setmapAux] = useState({});
  const [filterClose, setfilterClose] = useState(false);
  const [ManttoData, setManttoData] = useState({});
  const [search, setSearch] = useState("");
  const [severityFilter, setSeverityFilter] = useState([6]);
  const [statusFilter, setStatusFilter] = useState(["ok", "offline", "unknown"]);
  const [techFilter, setTechFilter] = useState([]);
  const [capas, setCapas] = useState({})
  const [showCorrelationsMO, setShowCorrelationsMO] = useState(true)
  const [showCorrelationsFO, setShowCorrelationsFO] = useState(true)
  const [groupFilter, setGroupFilter] = useState([]);
  const [zoneFilter, setZoneFilter] = useState([]);
  const [ackFilter, setAckFilter] = useState([]);
  const [ticketFilter, setTicketFilter] = useState([]);
  const [tipoFilter, setTipoFilter] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataAnalisis, setDataAnalisis] = useState({ data: {}, loading: true, error: {} })
  const [markersWOR, setMarkersWOR] = useState([])
  const [renderCapas, setRenderCapas] = useState({ downs: false, markersWOR: false, markers: true, rfid: true, switches: true, lpr: true, towers: false, exceptions: false })
  const [events, setEvents] = useState([]);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  // const wsRef = useRef(null);
  const firstLoadDone = useRef(false);
  const wsRef = useRef(null);
  //    useEffect(() => {
  //   const ws = new WebSocket(`${server.ws}/api/v1/cassia/affiliations_map_ws/`);
  //   wsRef.current = ws;

  //   ws.onopen = () => {
  //     setDataAnalisis({ data: [], loading: true, error: {} });
  //     setLoading(true);
  //   };

  //  ws.onmessage = (event) => {
  //   try {
  //     const response = JSON.parse(event.data);
  //     // console.log("Mensaje recibido:", response);

  //     // Normalizar siempre como array
  //     const eventsArray = Array.isArray(response) ? response : [response];
  //     // console.log("setDataAffiliation", eventsArray.length);
  //     setDataAffiliation(eventsArray[0]);
  //     setLoading(false);
  //     // console.log("eventsArray:", eventsArray);
  //     setDataAnalisis({ data: eventsArray.filter(e => !e.correlated_event_id), loading: false, error: {} });
  //   } catch (err) {
  //     // console.error("Error parseando mensaje:", err);
  //   }
  // };

  //   ws.onerror = (error) => {
  //     // console.error("Error en el WebSocket:", error);
  //     setLoading(false);
  //     setDataAnalisis((prev) => ({ ...prev, error }));
  //   };

  //   ws.onclose = () => {
  //     // console.log("WebSocket cerrado");
  //   };

  //   return () => {
  //     ws.close();
  //   };
  // }, [server.ws]);  
  useEffect(() => {
    const ws = new WebSocket(`${server.ws}/api/v1/cassia/affiliations_map_ws/`);
    wsRef.current = ws;

    ws.onopen = () => {
      setDataAnalisis({ data: [], loading: true, error: {} });
      setLoading(true);
      firstLoadDone.current = false; // Resetear al abrir
    };

    ws.onmessage = (event) => {
      // Si ya procesamos el primero, ignorar o cerrar
      if (firstLoadDone.current) return;

      try {
        const response = JSON.parse(event.data);
        const eventsArray = Array.isArray(response) ? response : [response];

        if (eventsArray.length > 0) {
          setDataAffiliation(eventsArray[0]);
          setDataAnalisis({
            data: eventsArray.filter(e => !e.correlated_event_id),
            loading: false,
            error: {}
          });
          setLoading(false);

          // MARCAR COMO COMPLETADO Y CERRAR
          firstLoadDone.current = true;
          ws.close(); // Cerramos la conexión voluntariamente
          // console.log("Primer mensaje recibido, cerrando WS para permitir simulaciones.");
        }
      } catch (err) {
        console.error("Error parseando mensaje:", err);
      }
    };

    ws.onerror = (error) => {
      setLoading(false);
      setDataAnalisis((prev) => ({ ...prev, error }));
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };
  }, [server.ws]);
  const afiliations = dataAffiliation?.affiliations || [];
  const correlations = dataAffiliation?.correlations || [];
  const dashboard_summary = dataAffiliation?.dashboard_summary || {};
  const technologies_catalog = dataAffiliation?.catalogs?.technologies || [];
  const groups_catalog = dataAffiliation?.catalogs?.groups || [];
  const zona_catalog = dataAffiliation?.catalogs?.zones || [];
  const [infoMarkerOpen, setInfoMarkerOpen] = useState(false);
  const [listStatusOpen, setListStatusOpen] = useState(false);
  const [statusSelected, setStatusSelected] = useState([])
  const [statusSelectedText, setStatusSelectedText] = useState([])
  const [infoMarker, setInfoMarker] = useState([])
  const [switchesFO, setSwitchesFO] = useState([]);
  const [switchesMO, setSwitchesMO] = useState([]);
  const [switchesDownFO, setSwitchesDownFO] = useState([]);
  const [switchesDownMO, setSwitchesDownMO] = useState([]);

  // console.log(afiliations)
  function openInfoMarker() {
    setInfoMarkerOpen(true);
  }

  function closeInfoMarker() {
    setInfoMarkerOpen(false);
  }
  const handleMarkerClick = (data) => {

    setInfoMarker(data)
    openInfoMarker()
  }
  function openStatusList() {
    setListStatusOpen(true);
  }

  function closeStatusList() {
    setListStatusOpen(false);
  }
  const handleStatusListClick = (data) => {
    switch (data) {
      case 'ok': setStatusSelectedText('Conectados'); break;
      case 'offline': setStatusSelectedText('Desconectados'); break;
      case 'unknown': setStatusSelectedText('Desconocidos'); break;
      case 'mtto': setStatusSelectedText('En Mantenimiento'); break;
      case 'except': setStatusSelectedText('En Excepción'); break;
      default: setStatusSelectedText(''); break;
    }


    const okHosts = (data == 'mtto' || data == 'except') ?
      (data == 'mtto' ?
        filteredEvents.flatMap(item =>
          Array.isArray(item.properties.hosts)
            ? item.properties.hosts
              .filter(h => h.in_maintenance === true)
              .map(h => ({
                ...h,
                parent_id: item.properties.hostidC // 👈 aquí agregas el id al que pertenece
              }))
            : [])
        :
        filteredEvents.flatMap(item =>
          Array.isArray(item.properties.hosts)
            ? item.properties.hosts
              .filter(h => h.is_exception === true)
              .map(h => ({
                ...h,
                parent_id: item.properties.hostidC // 👈 aquí agregas el id al que pertenece
              }))
            : [])
      )
      :
      (
        data == 'total' ?
          filteredEvents.flatMap(item =>
            Array.isArray(item.properties.hosts)
              ? item.properties.hosts

                .map(h => ({
                  ...h,
                  parent_id: item.properties.hostidC // 👈 aquí agregas el id al que pertenece
                }))
              : [])
          :
          filteredEvents.flatMap(item =>
            Array.isArray(item.properties.hosts)
              ? item.properties.hosts
                .filter(h => h.status === data)
                .map(h => ({
                  ...h,
                  parent_id: item.properties.hostidC // 👈 aquí agregas el id al que pertenece
                }))
              : [])
      )
    //      filteredEvents.flatMap(item =>
    // (item.properties.hosts || []).filter(host => host.status === data)


    setStatusSelected(okHosts)
    openStatusList()
  }

  useEffect(() => {
    loadFiltersFromLocalStorage()
  }, [])
  useEffect(() => {
    setMarkersWOR([])
    setSwitchesFO([])
    setSwitchesMO([])
    objeto_markers_wor()
    objeto_switches()
  }, [dataAffiliation])
  useEffect(() => {
    // //////console.log(renderCapas.markersWOR)
    if (markersWOR.length !== 0) {
      //////console.log('El proceso de markersWOR ha terminado',markersWOR.length);
      setRenderCapas(prevState => ({
        ...prevState,
        markersWOR: true
      }));
    }


  }, [markersWOR]);
  function objeto_markers_wor() {

    afiliations.map((host, index, array) => {

      // if (!flag_ubicacion) {
      //   if(host.length!==0 && host.latitude>=-90 && host.latitude<=90){
      //     setUbicacion({latitud:host.latitude,longitud:host.longitude,groupid:ubicacion.groupid,dispId:ubicacion.dispId,templateId:ubicacion.templateId})
      //     // //////console.log(host);
      //     flag_ubicacion=true
      //   }
      // }
      // // //////console.log(host.ip,host.latitude)
      if (host?.geo?.lat >= -90 && host?.geo?.lat <= 90) {

        // const hostidC = devices_data.relations.find(obj => obj.hostidC === host.hostid)
        // const hostidP = devices_data.relations.find(obj => obj.hostidCP === host.hostid)

        // const lon = devices_data.relations.find(obj => obj.end_lon === host.longitude)
        // const lat = devices_data.relations.find(obj => obj.end_lat === host.latitude)
        // const lon = devices_data.subgroup_info.find(obj => obj.longitude === host.longitude)
        // const lat = devices_data.subgroup_info.find(obj => obj.latitude === host.latitude)
        // const reset_info=devices_data.subgroup_info.find(obj => obj.hostid === host.hostid)
        // // console.log("***************************reset_info")
        // console.log(reset_info)
        // console.log("LEVEL:",((host.device_id==26 || host.device_id==4 || host.device_id==8 ) && reset_info!=undefined  && ubicacion.templateId!='')?((reset_info.metrics.length==0)?0:(reset_info.metrics[0].level==undefined?-1:reset_info.metrics[0].level)):-1)
        // console.log((reset_info.metrics.length==0)?'#4fb7f3':reset_info.metrics[0].value)
        // console.log(((reset_info.metrics.length==0)?'#4fb7f3':((reset_info.metrics[0].value>23)?'#00ff70':(reset_info.metrics[0].value>20)?'#ee5c08':'#ffee00')))
        let colorSG = '#00ff70'
        let severity = 0
        let tooltip = false;
        //  if(lon===undefined && lon===undefined){
        //   tooltip=true

        //  }
        //  else{
        //   tooltip=false
        //  }
        //azul #4fb7f3
        // verde "#1fee08"
        const levels_colors = ['#c1c1c1b0', '#00ff70', '#ffee00', '#ee5c08']
        // if(!exceptions_list.data.some(u => u.hostid === host.hostid)){
        setMarkersWOR(markersWOR => [...markersWOR, {
          type: 'Feature',
          properties: {
            hostidC: host.id,
            hostidP: '',
            end_lat: host.geo.lat,
            end_lon: host.geo.lng,
            name_hostC: host.name,
            name: host.name,
            hosts: host.hosts,
            stats: host.stats,
            tags: host.tags
            // color_alineacion2:(host.device_id==26 && ubicacion.templateId=='reset_extpwr')?((reset_info.metrics.length==0)?'#757575af':((reset_info.metrics[0].value>23)?'#00ff70':(reset_info.metrics[0].value<20)?'#ee5c08':'#ffee00')):colorSG,
            // color_alineacion:((host.device_id==26 || host.device_id==4 ||host.device_id==8) && reset_info!=undefined  && ubicacion.templateId!='')?((reset_info.metrics.length==0)?levels_colors[0]:levels_colors[reset_info.metrics[0].level]):colorSG,

            // metrics:((host.device_id==26 || host.device_id==4 ||host.device_id==8) && reset_info!=undefined)?reset_info.metrics:[],
            // level:((host.device_id==26 || host.device_id==4 || host.device_id==8 ) && reset_info!=undefined  && ubicacion.templateId!='')?((reset_info.metrics.length==0)?0:(reset_info.metrics[0].level==undefined?-1:reset_info.metrics[0].level)):-1,
            // status:(host.device_id==26 && ubicacion.templateId=='reset_extpwr')?((reset_info.metrics.length==0)?0:((reset_info.metrics[0].value>23)?1:(reset_info.metrics[0].value<20)?3:2)):-1
          },
          geometry: {
            type: 'Point',
            coordinates: [host.geo.lng, host.geo.lat],
          },
        }])
      } else { }


      /****************************************************************** */

      // }else{
      //   // ////////console.log(host)
      // }
    }
    )
  }
  const [switches, setSwitches] = useState([])
  //  console.log("switches",switches)
  useEffect(() => {
    //   console.log("actualiza switches tipe")
    //  console.log(switchesFO,switchesMO)
    if (switchesFO.length > 0 || switchesMO.length > 0) {
      setSwitches([switchesFO, switchesMO, switchesDownFO, switchesDownMO])
    }

  }, [switchesFO, switchesMO])
  function objeto_switches() {
    // console.log("entra al objeto switches -----------------------------")
    // console.log(correlations)

    if (correlations.length != 0) {
      correlations.map((host, index, array) => {
        // console.log(host)
        const sourcedata = afiliations.find(obj => obj.id === host.source)
        const targetdata = afiliations.find(obj => obj.id === host.target)

        // if(ubicacion.dispId===12){
        if (true) {
          if (host.length !== 0 && sourcedata?.geo?.lat >= -90 && sourcedata?.geo?.lat <= 90 && targetdata?.geo?.lat >= -90 && targetdata?.geo?.lat <= 90) {


            // console.log("indice"+index+" | tipo:"+host.medio_id+" | status: "+host.valor_status_enlace)
            // //////console.log(hostSub   )
            let alineacion = 0
            let severity = 0


            let colorSG = '#00ff70'


            if (host.valor_status_enlace == 1) {
              colorSG = 'lime'
              // severity=1
            } else if (host.valor_status_enlace == null) {
              colorSG = 'grey'
              // severity=1
            } else if (host.severity == 0) {
              colorSG = 'red'
              // severity=2
            }
            //azul #4fb7f3
            // verde "#1fee08"
            if (host.medio_id == 1) {
              // //////console.log("fibra optica")
              setSwitchesFO(switchesFO => [...switchesFO, {
                type: 'Feature',
                properties: {
                  correlarionid: host.relationid,
                  init_lat: sourcedata.geo.lat,
                  init_lon: sourcedata.geo.lng,
                  end_lat: targetdata.geo.lat,
                  end_lon: targetdata.geo.lng,
                  Metric: host,
                  status: host.status,
                  // name:host.name,
                  hostidC: targetdata.id,
                  hostidP: sourcedata.id,
                  //BitsSent: host.BitsSent,
                  color_alineacion: colorSG,
                  severity: host.severity,
                  type_connection: host.medio_id,
                  connectivity: host.status,
                  // severity:Math.floor(Math.random() * 4) + 1,
                  metrica: host.metrics,
                },
                geometry: {
                  type: 'LineString',
                  coordinates: [[sourcedata.geo.lng, sourcedata.geo.lat], [targetdata.geo.lng, targetdata.geo.lat]],
                },
              }])
            } else if (host.medio_id == 2) {

              setSwitchesMO(switchesMO => [...switchesMO, {
                type: 'Feature',
                properties: {
                  correlarionid: host.relationid,
                  init_lat: sourcedata.geo.lat,
                  init_lon: sourcedata.geo.lng,
                  end_lat: targetdata.geo.lat,
                  end_lon: targetdata.geo.lng,
                  Metric: host,
                  status: host.status,
                  // name:host.name,
                  hostidC: targetdata.id,
                  hostidP: sourcedata.id,
                  //BitsSent: host.BitsSent,
                  color_alineacion: colorSG,
                  severity: host.severity,
                  type_connection: host.medio_id,
                  connectivity: host.valor_status_enlace,
                  // severity:Math.floor(Math.random() * 4) + 1,
                  metrica: 'metricaSelected',
                },
                geometry: {
                  type: 'LineString',
                  coordinates: [[sourcedata.geo.lng, sourcedata.geo.lat], [targetdata.geo.lng, targetdata.geo.lat]],
                },
              }])
            } else if (host.medio_id == 1 && host.valor_status_enlace == 0) {
              // //////console.log("fibra optica")
              // setSwitchesDownFO(switchesDownFO =>[...switchesDownFO,{
              //   type: 'Feature',
              //   properties:{
              //     correlarionid: host.relationid,
              //     init_lat: host.lat_padre.replace(",", "."),
              //     init_lon: host.lon_padre.replace(",", "."),
              //     end_lat: host.lat_hijo.replace(",", "."),
              //     end_lon: host.lon_hijo.replace(",", "."),
              //     Metric:host,
              //    // name:host.name,
              //     hostidC: host.host_hijo_id,
              //     hostidP: host.host_padre_id,
              //     //BitsSent: host.BitsSent,
              //     color_alineacion:colorSG,
              //     severity:host.severity,
              //     type_connection: host.medio_id,
              //     connectivity:host.valor_status_enlace,
              //     // severity:Math.floor(Math.random() * 4) + 1,
              //     metrica:'metricaSelected',
              //   },
              //   geometry: {
              //     type: 'LineString',
              //     coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              //   },
              // }])
            } else if (host.medio_id == 2 && (host.valor_status_enlace == 1 || host.valor_status_enlace == null)) {
              // console.log("microonda")
              // setSwitchesMO(switchesMO =>[...switchesMO,{
              //   type: 'Feature',
              //   properties:{
              //     correlarionid: host.relationid,
              //     init_lat: host.lat_padre.replace(",", "."),
              //     init_lon: host.lon_padre.replace(",", "."),
              //     end_lat: host.lat_hijo.replace(",", "."),
              //     end_lon: host.lon_hijo.replace(",", "."),
              //     Metric:host,
              //    // name:host.name,
              //     hostidC: host.host_hijo_id,
              //     hostidP: host.host_padre_id,
              //     //BitsSent: host.BitsSent,
              //     color_alineacion:colorSG,
              //     severity:host.severity,
              //     type_connection: host.medio_id,
              //     connectivity:host.valor_status_enlace,
              //     // severity:Math.floor(Math.random() * 4) + 1,
              //     metrica:'metricaSelected',
              //   },
              //   geometry: {
              //     type: 'LineString',
              //     coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              //   },
              // }])
            } else if (host.medio_id == 2 && host.valor_status_enlace == 0) {
              // console.log("fibra optica")
              // setSwitchesDownMO(switchesDownMO =>[...switchesDownMO,{
              //   type: 'Feature',
              //   properties:{
              //     correlarionid: host.relationid,
              //     init_lat: host.lat_padre.replace(",", "."),
              //     init_lon: host.lon_padre.replace(",", "."),
              //     end_lat: host.lat_hijo.replace(",", "."),
              //     end_lon: host.lon_hijo.replace(",", "."),
              //     Metric:host,
              //    // name:host.name,
              //     hostidC: host.host_hijo_id,
              //     hostidP: host.host_padre_id,
              //     //BitsSent: host.BitsSent,
              //     color_alineacion:colorSG,
              //     severity:host.severity,
              //     type_connection: host.medio_id,
              //     connectivity:host.valor_status_enlace,
              //     // severity:Math.floor(Math.random() * 4) + 1,
              //     metrica:'',
              //   },
              //   geometry: {
              //     type: 'LineString',
              //     coordinates: [[host.lon_padre.replace(",", "."), host.lat_padre.replace(",", ".")], [host.lon_hijo.replace(",", "."), host.lat_hijo.replace(",", ".")]],
              //   },
              // }])
            }

            // setMarkers([markers1,markers2])
            //   //////console.log(markers1)
            //  //////console.log(markers2) 
            /****************************************************************** */

          }
        } else {

        }

      }
      )
    } else {
      setRenderCapas(prevState => ({
        ...prevState,
        switches: true
      }));
    }
  }
  const WarningIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2L2 20h20L12 2z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="12"
        y1="9"
        x2="12"
        y2="14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle
        cx="12"
        cy="17"
        r="1"
        fill="currentColor"
      />
    </svg>
  );


  const ToolsIcon = () => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="14" height="14" viewBox="0 0 1280 1230" preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0 1230) scale(0.1 -0.1)" fill="currentColor" stroke="none">
        <path d="M9265 12294 c-782 -78 -1373 -456 -1688 -1079 -182 -360 -257 -728
  -257 -1260 0 -188 8 -276 47 -505 34 -206 37 -357 7 -421 -26 -56 -82 -120
  -140 -160 -24 -16 -1590 -1444 -3480 -3174 -1891 -1730 -3445 -3145 -3454
  -3145 -10 0 -38 -22 -63 -49 -271 -290 -311 -750 -97 -1115 22 -37 40 -75 40
  -83 0 -8 19 -51 42 -95 68 -132 175 -268 209 -268 9 0 183 -149 386 -331 202
  -183 402 -357 445 -389 284 -213 680 -276 1010 -161 135 47 350 184 356 227 3
  22 71 90 1282 1284 432 426 958 946 1170 1155 212 210 1110 1096 1995 1969
  886 874 1711 1690 1835 1815 342 345 332 343 720 150 431 -213 664 -283 988
  -295 423 -16 805 60 1111 222 497 263 835 712 981 1304 15 63 33 144 39 180 6
  36 18 112 28 170 23 133 25 549 4 590 -20 38 -53 70 -71 70 -20 0 -419 186
  -441 206 -9 8 -37 14 -70 14 -48 0 -157 -39 -870 -314 -448 -172 -817 -311
  -821 -307 -12 11 -1070 1792 -1066 1796 1 1 374 233 828 515 454 282 843 530
  864 551 36 34 40 44 44 97 4 55 2 62 -31 105 -19 25 -51 72 -71 105 -31 52
  -51 69 -144 130 -397 257 -790 418 -1168 477 -95 15 -416 27 -499 19z"/>
      </g>
    </svg>

  );

  const [searchResults, setSearchResults] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  function matchesSearch2(item, searchTerm) {

    const term = (searchTerm || '').trim().toLowerCase();
    if (!term) return true; // si el buscador está vacío, mostrar todo

    // 1) Buscar en el id del objeto (top-level)

    if (String(item.properties.name || '').toLowerCase().includes(term)) return true;

    // 2) Buscar en la ip de cualquiera de los hosts
    if (Array.isArray(item.properties.hosts)) {
      const anyHostIpMatches = item.properties.hosts.some(h =>
        String(h.ip || '').toLowerCase().includes(term)
      );
      if (anyHostIpMatches) return true;
    }

    // devolver false explícito si no hubo coincidencias
    return false;
  }

  function filterFeatureByTechnology(feature, techFilter) {
    if (!Array.isArray(techFilter) || techFilter.length === 0) {
      return feature;
    }

    const allowedTechIds = techFilter.map(t => Number(t.value));

    const hosts = feature?.properties?.hosts || [];

    // 1️⃣ Filtrar hosts por tecnología
    const filteredHosts = hosts.filter(h =>
      allowedTechIds.includes(Number(h?.tech?.id))
    );

    // 2️⃣ Si no quedan hosts → eliminar afiliación
    if (filteredHosts.length === 0) return null;

    // 3️⃣ Recalcular stats (opcional pero recomendado)
    const breakdown = filteredHosts.reduce(
      (acc, h) => {
        acc[h.status] = (acc[h.status] || 0) + 1;
        return acc;
      },
      { ok: 0, offline: 0, unknown: 0, maintenance: 0, exceptions: 0 }
    );

    // 4️⃣ Recalcular technologies visibles
    const technologies = [
      ...new Map(
        filteredHosts.map(h => [h.tech.id, h.tech])
      ).values()
    ];

    // 5️⃣ Retornar feature limpia
    return {
      ...feature,
      properties: {
        ...feature.properties,
        hosts: filteredHosts,
        stats: {
          total_devices: filteredHosts.length,
          breakdown
        },
        tags: {
          ...feature.properties.tags,
          technologies
        }
      }
    };
  }


  function filterByGroups(item, filterSelected) {
    // Si NO hay filtros => mostrar todo
    if (!Array.isArray(filterSelected) || filterSelected.length === 0) {
      return true;
    }

    // IDs permitidos desde el array
    const allowedIds = filterSelected.map(f => Number(f.value));

    // Extraer groups del item
    const groups = item?.properties?.tags?.groups || [];

    // Checar si algún grupo coincide
    return groups.some(g => allowedIds.includes(Number(g.id)));
  }
  function filterFeatureByGroups(feature, groupFilter) {
    if (!Array.isArray(groupFilter) || groupFilter.length === 0) {
      return feature;
    }

    const allowedGroupIds = groupFilter.map(g => Number(g.value));

    const hosts = feature?.properties?.hosts || [];

    // 1️⃣ Filtrar hosts que pertenezcan a ALGUNO de los grupos
    const filteredHosts = hosts.filter(h =>
      Array.isArray(h.groups) &&
      h.groups.some(g => allowedGroupIds.includes(Number(g.id)))
    );

    // 2️⃣ Si no quedan hosts → eliminar afiliación
    if (filteredHosts.length === 0) return null;

    // 3️⃣ Recalcular stats
    const breakdown = filteredHosts.reduce(
      (acc, h) => {
        acc[h.status] = (acc[h.status] || 0) + 1;
        return acc;
      },
      { ok: 0, offline: 0, unknown: 0, maintenance: 0, exceptions: 0 }
    );

    // 4️⃣ Recalcular grupos visibles
    const groups = [
      ...new Map(
        filteredHosts
          .flatMap(h => h.groups || [])
          .map(g => [g.id, g])
      ).values()
    ];

    // 5️⃣ Retornar feature limpia
    return {
      ...feature,
      properties: {
        ...feature.properties,
        hosts: filteredHosts,
        stats: {
          total_devices: filteredHosts.length,
          breakdown
        },
        tags: {
          ...feature.properties.tags,
          groups
        }
      }
    };
  }

  function filterFeatureByZones(feature, zoneFilter) {
    if (!Array.isArray(zoneFilter) || zoneFilter.length === 0) {
      return feature;
    }

    const allowedZoneIds = zoneFilter.map(z => Number(z.value));

    const hosts = feature?.properties?.hosts || [];

    // 1️⃣ Filtrar hosts que tengan ALGUNA de las zonas seleccionadas
    const filteredHosts = hosts.filter(h =>
      Array.isArray(h.zones) &&
      h.zones.some(z => allowedZoneIds.includes(Number(z.id)))
    );

    // 2️⃣ Si no quedan hosts → eliminar afiliación
    if (filteredHosts.length === 0) return null;

    // 3️⃣ Recalcular stats
    const breakdown = filteredHosts.reduce(
      (acc, h) => {
        acc[h.status] = (acc[h.status] || 0) + 1;
        return acc;
      },
      { ok: 0, offline: 0, unknown: 0, maintenance: 0, exceptions: 0 }
    );

    // 4️⃣ Recalcular zonas visibles
    const zones = [
      ...new Map(
        filteredHosts
          .flatMap(h => h.zones || [])
          .map(z => [z.id, z])
      ).values()
    ];

    // 5️⃣ Retornar feature limpia
    return {
      ...feature,
      properties: {
        ...feature.properties,
        hosts: filteredHosts,
        stats: {
          total_devices: filteredHosts.length,
          breakdown
        },
        tags: {
          ...feature.properties.tags,
          zones
        }
      }
    };
  }

  function applyStatusFilter(afiliacion, statusFilter) {
    // Si no hay filtro, deja pasar tal cual
    if (!Array.isArray(statusFilter) || statusFilter.length === 0) {
      return afiliacion;
    }

    const hosts = afiliacion.properties.hosts || [];

    // 🔴 CLAVE: si hay filtro y no hay hosts → eliminar afiliación
    if (hosts.length === 0) {
      return null;
    }

    const allowed = statusFilter.map(s => s.toLowerCase());

    const filteredHosts = hosts.filter(h =>
      allowed.includes(h.status.toLowerCase())
    );

    // 🔴 Si ningún host coincide → eliminar afiliación
    if (filteredHosts.length === 0) {
      return null;
    }

    return {
      ...afiliacion,
      properties: {
        ...afiliacion.properties,
        hosts: filteredHosts
      }
    };
  }
  function filterByMttoExcept(e, mttoExceptFilter) {
    if (!Array.isArray(mttoExceptFilter) || mttoExceptFilter.length === 0) {
      return true; // no filtra nada
    }

    const hosts = e?.properties?.hosts || [];
    if (hosts.length === 0) return false;

    const hasMtto = hosts.some(h => h.in_maintenance === true);
    const hasExcept = hosts.some(h => h.is_exception === true);

    if (
      mttoExceptFilter.includes('mtto') &&
      mttoExceptFilter.includes('except')
    ) {
      return hasMtto || hasExcept;
    }

    if (mttoExceptFilter.includes('mtto')) {
      return hasMtto;
    }

    if (mttoExceptFilter.includes('except')) {
      return hasExcept;
    }

    return true;
  }
  function filterFeatureByMttoExcept(feature, mttoExceptFilter) {
    if (!Array.isArray(mttoExceptFilter) || mttoExceptFilter.length === 0) {
      return feature;
    }

    const hosts = feature?.properties?.hosts || [];

    // 1️⃣ Filtrar hosts según reglas
    const filteredHosts = hosts.filter(h => {
      const isMtto = h.in_maintenance === true;
      const isExcept = h.is_exception === true;

      if (
        mttoExceptFilter.includes('mtto') &&
        mttoExceptFilter.includes('except')
      ) {
        return isMtto || isExcept;
      }

      if (mttoExceptFilter.includes('mtto')) {
        return isMtto;
      }

      if (mttoExceptFilter.includes('except')) {
        return isExcept;
      }

      return true;
    });

    // 2️⃣ Si no quedan hosts → eliminar afiliación
    if (filteredHosts.length === 0) return null;

    // 3️⃣ Recalcular stats
    const breakdown = filteredHosts.reduce(
      (acc, h) => {
        acc[h.status] = (acc[h.status] || 0) + 1;
        return acc;
      },
      { ok: 0, offline: 0, unknown: 0, maintenance: 0, exceptions: 0 }
    );

    return {
      ...feature,
      properties: {
        ...feature.properties,
        hosts: filteredHosts,
        stats: {
          total_devices: filteredHosts.length,
          breakdown
        }
      }
    };
  }
  const filteredEvents = useMemo(() => {
    return markersWOR.map(e => applyStatusFilter(e, statusFilter))
      .filter(Boolean)
      .map(e => filterFeatureByTechnology(e, techFilter))
      .filter(Boolean)
      .map(e => filterFeatureByZones(e, zoneFilter))
      .filter(Boolean)
      .map(e => filterFeatureByGroups(e, groupFilter))
      .filter(Boolean)
      .map(e => filterFeatureByMttoExcept(e, ackFilter))
      .filter(Boolean)
      .filter((e) => {

        const matchesSearch = searchTerm === '' || matchesSearch2(e, searchTerm)

        //           const matchesTech =
        // techFilter.length === 0 || filterByTechnologies(e, techFilter)


        //          const matchesGroup =
        // groupFilter.length === 0 || filterByGroups(e, groupFilter)

        //    const matchesZone =
        // zoneFilter.length === 0 ||filterByZones(e, zoneFilter)

        // const matchesAck =
        //   ackFilter.length === 0 || filterByMttoExcept(e, ackFilter)

        return (

          matchesSearch
          // matchesTech &&
          // matchesAck
          //  &&
          // matchesGroup
          // matchesZone 
        );
      });

  }, [markersWOR, severityFilter, statusFilter, techFilter, groupFilter, zoneFilter, searchTerm, ackFilter]);
  useEffect(() => {
    saveFiltersToLocalStorage();
  }, [severityFilter, statusFilter, techFilter, groupFilter, zoneFilter, searchTerm, ackFilter, showCorrelationsFO, showCorrelationsMO]);
  var dataList = filteredEvents.length > 0 ? filteredEvents : [];
  function saveFiltersToLocalStorage() {
    const filtersState = {
      searchTerm: searchTerm,
      severities: severityFilter,
      statuses: statusFilter,
      techs: techFilter,
      groups: groupFilter,
      zones: zoneFilter,
      ack: ackFilter,
      ticket: ticketFilter,
      tipo: tipoFilter,
      showCorrelationsFO: showCorrelationsFO,
      showCorrelationsMO: showCorrelationsMO
    };
    localStorage.setItem('eventFilters', JSON.stringify(filtersState));
  }
  function loadFiltersFromLocalStorage() {
    const savedFilters = localStorage.getItem('eventFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);

      setSearchTerm(filters.searchTerm || '');
      setSeverityFilter(filters.severities || []);
      setStatusFilter(filters.statuses || []);
      setTechFilter(filters.techs || []);
      setGroupFilter(filters.groups || []);
      setZoneFilter(filters.zones || []);
      setAckFilter(filters.ack || []);
      setTicketFilter(filters.ticket || []);
      setTipoFilter(filters.tipo || []);
      setShowCorrelationsFO(filters.showCorrelationsFO || true);
      setShowCorrelationsMO(filters.showCorrelationsMO || true);
    }
  }

  // input: feature (tu objeto Feature) o un array de hosts
  function computeHostCounters(input) {
    const hosts = Array.isArray(input)
      ? input
      : (input && input.properties && Array.isArray(input.properties.hosts))
        ? input.properties.hosts
        : [];

    const counters = {
      totalHosts: 0,
      connected: 0,
      connectedInMaintenance: 0,
      connectedExceptions: 0,
      disconnected: 0,
      // opcional: breakdown por status
      byStatus: {}
    };

    counters.totalHosts = hosts.length;

    hosts.forEach(h => {
      // defensivo: normalizar valores
      const status = (h?.status || '').toString().toLowerCase();
      const inMaintenance = !!h?.in_maintenance;
      const isException = !!h?.is_exception;

      // contar por status
      counters.byStatus[status] = (counters.byStatus[status] || 0) + 1;

      if (status === 'ok') {
        counters.connected += 1;
        if (inMaintenance) counters.connectedInMaintenance += 1;
        if (isException) counters.connectedExceptions += 1;
      } else {
        // considerar desconectado todo lo que NO sea 'ok'
        counters.disconnected += 1;
      }
    });

    return counters;
  }



  function updateStats(filteredEvents) {
    // init
    const stats = {
      totalHosts: 0,

      // por estado
      ok: 0,
      down: 0,      // incluye "offline"
      unknown: 0,

      // mantenimiento / excepciones generales
      maintenance: 0,
      exceptions: 0,

      // combinaciones por estado
      ok_maintenance: 0,
      ok_exceptions: 0,

      down_maintenance: 0,
      down_exceptions: 0,

      unknown_maintenance: 0,
      unknown_exceptions: 0,

      // totales globales solicitados
      total_maintenance: 0,
      total_exceptions: 0
    };

    // Normalizar entrada a un array de hosts
    const featuresArray = Array.isArray(filteredEvents)
      ? filteredEvents
      : (filteredEvents?.features ?? []);

    // Si filteredEvents es un array de hosts (no features), detectarlo:
    const looksLikeHostsArray = Array.isArray(filteredEvents) &&
      filteredEvents.length > 0 &&
      typeof filteredEvents[0] === 'object' &&
      ('status' in filteredEvents[0] || 'ip' in filteredEvents[0]);

    // Helper para procesar un host individual
    function processHost(h) {
      const statusRaw = (h?.status ?? '').toString().toLowerCase().trim();
      // Normalizar synonyms: treat 'offline' as 'down'
      const status = statusRaw === 'offline' ? 'down' : statusRaw;

      const inMaint = !!(h?.in_maintenance ?? h?.maintenance);
      const isExcept = !!(h?.is_exception ?? h?.exceptions);

      // totals
      stats.totalHosts += 1;
      if (inMaint) stats.maintenance += 1;
      if (isExcept) stats.exceptions += 1;
      if (inMaint) stats.total_maintenance += 1;
      if (isExcept) stats.total_exceptions += 1;

      // state-specific counters
      if (status === 'ok') {
        stats.ok += 1;
        if (inMaint) stats.ok_maintenance += 1;
        if (isExcept) stats.ok_exceptions += 1;
      } else if (status === 'down') {
        stats.down += 1;
        if (inMaint) stats.down_maintenance += 1;
        if (isExcept) stats.down_exceptions += 1;
      } else if (status === 'unknown') {
        stats.unknown += 1;
        if (inMaint) stats.unknown_maintenance += 1;
        if (isExcept) stats.unknown_exceptions += 1;
      } else {
        // otros estados los ignoramos para los counters por estado
      }
    }

    if (looksLikeHostsArray) {
      // caso: filteredEvents es array directo de hosts
      filteredEvents.forEach(h => processHost(h));
    } else {
      // filteredEvents es array de features -> recorrer y extraer hosts
      featuresArray.forEach(f => {
        const hosts = Array.isArray(f?.properties?.hosts)
          ? f.properties.hosts
          : Array.isArray(f?.hosts)
            ? f.hosts
            : [];

        hosts.forEach(h => processHost(h));
      });
    }

    return stats;
  }

  const stats = updateStats(filteredEvents);
  // console.log(dashboard_summary);
  //       // console.log(dataList)
  // console.log(stats);
  return (
    <>
      <div className="main-monitor-panel">
        {loading ? (
          <LoadData languaje={languaje} mode={mode} />
        ) : (
          <>
            <div className="monitor-panel-header">
              <div className="monitor-panel-header-compact">
                <AffStatBarNew
                  stats={stats}
                  filteredEvents={filteredEvents}
                  handleStatusListClick={handleStatusListClick}
                />
              </div>
            </div>
            {/* <div className="monitor-panel-body">
          <div className={"monitor-panel-filter-container "+((filterClose)?"close":'')} >
              <div className={"monitor-panel-filter-header "+((filterClose)?"close":'')} onClick={()=>{setfilterClose(!filterClose)}}>
                  <div className="monitor-panel-filter-title-img">
                       <img  src={"/iconos/"+((filterClose)?"filtros":"close_x")+".png"}alt="Icono" style={{width:'20px',height:'20px',marginRight:'5px'}}/>
                  </div>
                  <div className="monitor-panel-filter-title-text">
                  <span>{"Filtros"}</span>
                  </div>
                  <hr style={{
                      display: (filterClose) ? "none" : "block",
                      color: "black",
                  height: "10px",
                  width: "90%",
                  top: "40%",
                  position: "relative",
                  left: "-17%"

                  }}/>
              </div>
              <div className="monitor-panel-filter-body" style={{display:(filterClose)?"none":"block"}}>
                  <FilterPanel 
                  statusFilter={statusFilter}
                  techFilter={techFilter}
              groupFilter={groupFilter}
              zoneFilter={zoneFilter}
              ackFilter={ackFilter}
              ticketFilter={ticketFilter} 
              severityFilter={severityFilter} 
              tipoFilter={tipoFilter}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              // Pasa las funciones 'setter' para que el hijo pueda actualizarlos
              setStatusFilter={setStatusFilter}
              setTechFilter={setTechFilter}
              setGroupFilter={setGroupFilter}
              setZoneFilter={setZoneFilter}
              setAckFilter={setAckFilter}
              setTicketFilter={setTicketFilter}
              setTipoFilter={setTipoFilter}
              setSeverityFilter={setSeverityFilter} 
              setShowCorrelationsFO={setShowCorrelationsFO}
              setShowCorrelationsMO={setShowCorrelationsMO}
              showCorrelationsFO={showCorrelationsFO}
              showCorrelationsMO={showCorrelationsMO}
              server={server}
              technologies_catalog={technologies_catalog}
              groups_catalog={groups_catalog}
              zona_catalog={zona_catalog}
                  isOpen={true}languaje={languaje} mode={mode} ubicacion={ubicacion} setUbicacion={setUbicacion} hostSelected={hostSelected} setHostSelected={setHostSelected} dataServers={dataServers} listSelected={listSelected} techSelected={techSelected} openAddHostModal={openAddHostModal} dataCriticalities={dataCriticalities} showHistoric={showHistoric} mapAux={mapAux} ManttoData={ManttoData} setManttoData={setManttoData}/>
              
              </div>
          </div>
          <div className="monitor-panel-map-container">
                {(renderCapas.markersWOR)&&
                <MapboxAfiliation showCorrelationsMO={showCorrelationsMO} showCorrelationsFO={showCorrelationsFO} statusFilter={statusFilter} switchesMO={switchesMO} switchesFO={switchesFO} handleMarkerClick={handleMarkerClick} filteredEvents={filteredEvents}markersWOR={dataList} languaje={languaje} ubicacion={ubicacion} setUbicacion={setUbicacion} global_longitud={global_longitud} global_latitude={global_latitude} dataAgencies={dataAgencies} global_zoom={global_zoom} setmapAux={setmapAux} mapAux={mapAux}/>
                }
          </div>
                               <PanelCorrelaciones markerWOR={markersWOR} setMarkerWOR={setMarkersWOR}  CreateCisModalOpen={CreateCisModalOpen} mode={mode}    mapAux={mapAux} setmapAux={setmapAux} setDataAffiliation={setDataAffiliation} setDataAnalisis={setDataAnalisis}></PanelCorrelaciones>

        </div> */}
            <div className="monitor-panel-body">

              {/* ── PANEL FILTROS ── */}
              <div
                style={{
                  width: filterClose ? '38px' : '210px',
                  flexShrink: 0,
                  background: 'rgba(255,255,255,0.97)',
                  border: '1px solid #e2e8f0',
                  borderRadius: 10,
                  boxShadow: '0 4px 16px rgba(0,0,0,.1)',
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                  transition: 'width .2s ease',
                  height: 'fit-content',
                  maxHeight: '70%',
                  position: 'absolute',
                  top: ' 20%',
                  left: 10,
                  zIndex: 21
                }}
              >

                {/* Header — fondo azul marino, siempre visible */}
                <div
                  onClick={() => setfilterClose(!filterClose)}
                  style={{
                    background: '#0f2d5e',
                    padding: filterClose ? '9px 10px' : '9px 12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7,
                    cursor: 'pointer',
                    flexShrink: 0,
                    justifyContent: filterClose ? 'center' : 'space-between',
                    userSelect: 'none'
                  }}
                >
                  {/* Ícono sliders siempre visible */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
                      <line x1="2" y1="5" x2="14" y2="5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                      <line x1="2" y1="11" x2="14" y2="11" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                      <circle cx="5" cy="5" r="1.8" fill="#0f2d5e" stroke="#fff" strokeWidth="1.3" />
                      <circle cx="11" cy="11" r="1.8" fill="#0f2d5e" stroke="#fff" strokeWidth="1.3" />
                    </svg>

                    {/* Texto solo cuando está expandido */}
                    {!filterClose && (
                      <span style={{ fontSize: 12, fontWeight: 500, color: '#fff', whiteSpace: 'nowrap' }}>
                        Filtros
                      </span>
                    )}
                  </div>

                  {/* Chevron solo cuando está expandido */}
                  {!filterClose && (
                    <svg
                      width="10" height="10" viewBox="0 0 10 10"
                      style={{ flexShrink: 0, transition: 'transform .2s', transform: filterClose ? 'rotate(-90deg)' : 'rotate(0deg)' }}
                    >
                      <polyline
                        points="2,3.5 5,6.5 8,3.5"
                        fill="none" stroke="rgba(255,255,255,.6)"
                        strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>

                {/* Body — oculto cuando está colapsado */}
                {!filterClose && (
                  <div style={{ flex: 1, overflowY: 'auto', padding: '0 12px 12px' }}>
                    <FilterPanel
                      statusFilter={statusFilter}
                      techFilter={techFilter}
                      groupFilter={groupFilter}
                      zoneFilter={zoneFilter}
                      ackFilter={ackFilter}
                      ticketFilter={ticketFilter}
                      severityFilter={severityFilter}
                      tipoFilter={tipoFilter}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      setStatusFilter={setStatusFilter}
                      setTechFilter={setTechFilter}
                      setGroupFilter={setGroupFilter}
                      setZoneFilter={setZoneFilter}
                      setAckFilter={setAckFilter}
                      setTicketFilter={setTicketFilter}
                      setTipoFilter={setTipoFilter}
                      setSeverityFilter={setSeverityFilter}
                      setShowCorrelationsFO={setShowCorrelationsFO}
                      setShowCorrelationsMO={setShowCorrelationsMO}
                      showCorrelationsFO={showCorrelationsFO}
                      showCorrelationsMO={showCorrelationsMO}
                      server={server}
                      technologies_catalog={technologies_catalog}
                      groups_catalog={groups_catalog}
                      zona_catalog={zona_catalog}
                      isOpen={true}
                      languaje={languaje}
                      mode={mode}
                      ubicacion={ubicacion}
                      setUbicacion={setUbicacion}
                      hostSelected={hostSelected}
                      setHostSelected={setHostSelected}
                      dataServers={dataServers}
                      listSelected={listSelected}
                      techSelected={techSelected}
                      openAddHostModal={openAddHostModal}
                      dataCriticalities={dataCriticalities}
                      showHistoric={showHistoric}
                      mapAux={mapAux}
                      ManttoData={ManttoData}
                      setManttoData={setManttoData}
                    />
                  </div>
                )}
              </div>

              {/* ── MAPA ── */}
              <div className="monitor-panel-map-container">
                {(renderCapas.markersWOR) &&
                  <MapboxAfiliation
                    showCorrelationsMO={showCorrelationsMO}
                    showCorrelationsFO={showCorrelationsFO}
                    statusFilter={statusFilter}
                    switchesMO={switchesMO}
                    switchesFO={switchesFO}
                    handleMarkerClick={handleMarkerClick}
                    filteredEvents={filteredEvents}
                    markersWOR={dataList}
                    languaje={languaje}
                    ubicacion={ubicacion}
                    setUbicacion={setUbicacion}
                    global_longitud={global_longitud}
                    global_latitude={global_latitude}
                    dataAgencies={dataAgencies}
                    global_zoom={global_zoom}
                    setmapAux={setmapAux}
                    mapAux={mapAux}
                  />
                }
              </div>

              <PanelCorrelaciones
                markerWOR={markersWOR}
                setMarkerWOR={setMarkersWOR}
                CreateCisModalOpen={CreateCisModalOpen}
                mode={mode}
                mapAux={mapAux}
                setmapAux={setmapAux}
                setDataAffiliation={setDataAffiliation}
                setDataAnalisis={setDataAnalisis}
              />

            </div>
          </>
        )}
      </div>
      <Modal
        isOpen={infoMarkerOpen}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeInfoMarker}
        style={infoMarkerStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalHostList filteredEvents={filteredEvents} ToolsIcon={ToolsIcon} WarningIcon={WarningIcon} infoMarker={infoMarker} source={''} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setLoading={false} setError={'setError'} closHostsListModal={closeInfoMarker}></ModalHostList>

        {/* <InfoMarker   handleShowPopup={handleShowPopup} suveryId={suveryId} setSuveryId={setSuveryId} setImportModalOpen={setImportModalOpen} languaje={languaje}  dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies} mode={mode} downs_list={downs_list} userPermissions={userPermissions} source={'Monitoreo'} mapAux={mapAux} setmapAux={setmapAux} search_problems={search_problems} devices={devices} server={server} isOpen={infoMarkerOpen} data={infoMarker} closeInfoMarker={closeInfoMarker} ubiActual={ubiActual}></InfoMarker> */}
      </Modal>
      <Modal
        isOpen={listStatusOpen}
        onRequestClose={closeStatusList}
        style={statusListModalStyles}
        contentLabel="Device Status List"
      >
        <ModalHostStatusListNew
          statusSelectedText={statusSelectedText}
          statusSelected={statusSelected}
          filteredEvents={filteredEvents}
          source={''}
          handleShowPopup={handleShowPopup}
          languaje={languaje}
          mode={mode}
          server={server}
          closHostsListModal={closeStatusList}
        />
      </Modal>
    </>)
};

export default PanelAfiliationMap;
